module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("14rXI"))).then(() => parcelRequire('2KbAe'));